import { useSearchParams } from "react-router-dom";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { Header, Card, CardBody, Button } from "../../components/ui";
import { IconAlertCircle } from "@tabler/icons-react";
import PersonForm from "../../components/PersonForm";

const CreatePerson = () => {
    const [searchParams] = useSearchParams();
    const type = searchParams.get('type') || 'PARENT'; // Default to 'PARENT' if not specified
    const { user } = useCurrentUser();

    // Check if user has an adult person - if so, show access denied
    const hasAdultPerson = user?.person?.some(person => person.type === 'ADULT');
    const isParentCreatingParent = user?.person?.some(person => person.type === 'PARENT' && type === 'PARENT');

    if (hasAdultPerson || isParentCreatingParent) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
                <Header
                    userEmail={user?.email}
                    actions={
                        <a href="/main" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                            Späť na profil
                        </a>
                    }
                />
                <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <Card>
                        <CardBody>
                            <div className="text-center">
                                <IconAlertCircle className="h-12 w-12 text-red-600 mx-auto mb-4" />
                                <h2 className="text-xl font-semibold text-gray-900 mb-2">Prístup odmietnutý</h2>
                                <p className="text-gray-600 mb-6">
                                    {hasAdultPerson && (
                                        <span className="block mt-2 text-sm text-gray-500">
                                            Dospelí študenti nemôžu vytvoriť ďalšie osoby. Táto funkcia je dostupná len pre rodičov.
                                        </span>
                                    )}
                                    {isParentCreatingParent && (
                                        <span className="block mt-2 text-sm text-gray-500">
                                            Rodičia nemôžu vytvoriť ďalších rodičov.
                                        </span>
                                    )}
                                </p>
                                <Button
                                    onClick={() => window.location.href = '/main'}
                                    className="bg-blue-600 hover:bg-blue-700"
                                >
                                    Späť na profil
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
            <Header
                userEmail={user?.email}
                actions={
                    <a href="/main" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                        Späť na profil
                    </a>
                }
            />

            <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <Card>
                    <CardBody>
                        <PersonForm
                            personType={type as 'PARENT' | 'ADULT' | 'KID'}
                            userEmail={user?.email}
                            existingPersonData={{
                                address: user?.person?.[0]?.address,
                                houseNumber: user?.person?.[0]?.houseNumber,
                                city: user?.person?.[0]?.city,
                                psc: user?.person?.[0]?.psc,
                                phone: user?.person?.[0]?.phone
                            }}
                        />
                    </CardBody>
                </Card>
            </div>
        </div>
    );
}

export default CreatePerson;